import React from "react";
import { storyblokEditable, renderRichText } from "@storyblok/react";
import { BasicPanelContentModel } from "./BasicPanelContentModel";

import "./BasicPanelContent.css";
import Utils from "../../core/Utils/Utils";

const BasicPanelContent: React.FC<{ blok: BasicPanelContentModel }> = ({
  blok,
}) => {
  const hasImage = blok.image && blok.image?.filename ? true : false;
  const classHasImage = hasImage ? "has-image" : "";
  const bodyHTML = renderRichText(blok.body) || "";

  return (
    <div
      {...storyblokEditable(blok)}
      className={`basic-panel-container ${classHasImage} ${blok.displayImage}`}
    >
      <div className="mobile-title">
        <span>{blok.header}</span>
      </div>
      <div className="basic-panel-content">
        <div className="basic-panel-text">
          <div className="title">
            <span>{blok.header}</span>
          </div>
          <div dangerouslySetInnerHTML={{ __html: bodyHTML }}></div>
        </div>
        <div className="basic-panel-immage">
          {blok.image?.filename && (
            <img
              src={Utils.getCacheUrl(blok.image.filename)}
              alt=""
              onError={(e) => Utils.handleImageError(e, blok?.image?.filename)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default BasicPanelContent;
